import React from 'react';
import { motion } from 'framer-motion';
import { Compass, BarChart3, TrendingUp, Target, Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
import { Section } from './ui/Section';
import { openSurvey } from './SurveyModal';
export function DiagnosticSection() {
  const handleStartDiagnostic = () => {
    // Clear the localStorage to allow retaking
    localStorage.removeItem('armar_survey_completed');
    openSurvey();
  };
  return <Section id="diagnostic" className="bg-transparent py-16 md:py-24" data-id="element-95">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-96">
        <div className="relative bg-gradient-to-br from-[#0a0a3a]/80 via-[#0f0f5c]/80 to-[#1a1a80]/80 backdrop-blur-xl rounded-2xl md:rounded-3xl border border-white/10 overflow-hidden" data-id="element-97">
          {/* Decorative gradient orbs */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-98" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-purple-500/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-99" />

          <div className="relative z-10 p-6 md:p-12" data-id="element-100">
            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-101">
              {/* Left side - Icon */}
              <div className="shrink-0" data-id="element-102">
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-blue-500/20 via-indigo-500/20 to-purple-500/20 border border-blue-500/30 flex items-center justify-center" data-id="element-103">
                  <Compass className="w-12 h-12 md:w-16 md:h-16 text-blue-400" data-id="element-104" />
                </div>
              </div>

              {/* Right side - Content */}
              <div className="flex-1 text-center md:text-left" data-id="element-105">
                {/* Badge */}
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-500/20 border border-blue-500/30 mb-4" data-id="element-106">
                  <Sparkles className="w-4 h-4 text-blue-400" data-id="element-107" />
                  <span className="text-blue-400 text-sm font-medium" data-id="element-108">
                    Діагностичний тест
                  </span>
                </div>

                {/* Title */}
                <h2 className="text-2xl md:text-4xl font-bold text-white mb-3" data-id="element-109">
                  «На якому рівні спіралі розвитку{' '}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400" data-id="element-110">
                    знаходиться Ваш бізнес
                  </span>
                  »
                </h2>

                {/* Description */}
                <p className="text-gray-300 text-base md:text-lg mb-6 leading-relaxed" data-id="element-111">
                  Давайте чесно перевіримо, де Ви зараз і що заважає перейти на
                  наступний рівень.
                </p>

                {/* Benefits */}
                <div className="bg-white/5 border border-white/10 rounded-xl p-4 md:p-5 mb-6" data-id="element-112">
                  <p className="text-gray-200 font-medium mb-3 text-sm md:text-base" data-id="element-113">
                    Пройдіть короткий тест – і Ви отримаєте:
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-114">
                    {[{
                    icon: BarChart3,
                    text: 'розуміння свого поточного управлінського рівня'
                  }, {
                    icon: TrendingUp,
                    text: 'зони росту бізнесу'
                  }, {
                    icon: Target,
                    text: 'підказку, який наступний крок дасть найбільший ефект'
                  }].map((item, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-115">
                        <div className="p-1.5 rounded-lg bg-blue-500/20 text-blue-400 shrink-0" data-id="element-116">
                          <item.icon className="w-4 h-4" data-id="element-117" />
                        </div>
                        <span className="text-gray-300 text-xs md:text-sm leading-relaxed" data-id="element-118">
                          {item.text}
                        </span>
                      </div>)}
                  </div>
                </div>

                {/* Footer */}
                <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-119">
                  <Button size="lg" onClick={handleStartDiagnostic} withArrow data-id="element-120">
                    Почати
                  </Button>
                  <span className="text-gray-400 text-sm" data-id="element-121">
                    Займе 3–4 хвилини
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </Section>;
}